import 'css/src/components/public-pages/PageListing';

import React from 'react';

import ContentfulImageOrVideo from 'js/src/components/public-pages/ContentfulImageOrVideo';
import type { ImmutableMap } from 'js/src/libs/consts';
import type { ContentfulPageType } from 'js/src/libs/contentful-utils';

type Props = {
    data: ImmutableMap<{
        pages: Array<ContentfulPageType>;
    }>;
    bgColor: string;
    lazyLoad: boolean;
};

const PageListing = React.memo(function PageListing({ data, bgColor, lazyLoad }: Props) {
    if (!data.get('pages')) {
        return null;
    }

    const pageNodes = data.get('pages').map((page, index: number) => {
        return (
            <div className="col-md-3 col-sm-6 mb-l5-48" key={index}>
                <a href={`/${page.get('slug')}`}>
                    <ContentfulImageOrVideo
                        data={page.get('image')}
                        style={{ width: '100%', borderRadius: '10px' }}
                        urlWidth={400}
                        lazyLoad={lazyLoad}
                    />
                    <h5 className="mt-l5-16 page-title">{page.get('link_text')}</h5>
                    <p className="font-l5 font-l5--small page-description">
                        {page.get('description')}
                    </p>
                </a>
            </div>
        );
    });
    return (
        <div
            className="contentful-component page-listing pb-l5-0"
            style={{ backgroundColor: bgColor }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">{pageNodes}</div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PageListing;
